/* DeviceRestoreViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./DeviceRestoreViewRenderer");

class DeviceRestoreViewComponent extends EventEmitter {
    constructor(logger, gameEditor, userSession, MUF, steveIo, DeviceBackupConfiguration, state) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._modalUserFeedback = MUF;
        this._deviceBackupConfiguration = DeviceBackupConfiguration;
        this._backupConfigId = state.backupConfigId || null;
        this._activeOrgId = userSession.activeOrganization.id;

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    get canRestoreBackup() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceRestoreRun") > -1;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _registerTemplateListeners() {
        this._unRegisterTemplateListeners();
        // this._templateEntity.on("PristinePropertiesChanged", this._onPristinePropertiesChanged);
    }

    _unRegisterTemplateListeners() {
        // this._templateEntity.removeListener("PristinePropertiesChanged", this._onPristinePropertiesChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    get gameEditor() {
        return this.getGameEditor();
    }
    getGameEditor() {
        return this._gameEditor;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._backupsFeed = undefined;
            },
            (err) => {
                this._logger.warn(err, "DeviceRestoreViewComponent.shutdown() error.");
            }
        );
    }

    get logger() {
        return this.getLogger();
    }
    getLogger() {
        return this._logger;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    whenModelIsReady() {
        return this._gameEditor
            .whenDeviceIsReady()
            .then(() => {
                this._device = this._gameEditor.getDevice();
                return this._device.loadRelatedDeviceBackupConfigurations();
            })
            .then((backups) => {
                this._backupsFeed = backups;
                this._generateDataForSlick();
                return Promise.resolve();
            })
            .catch((err) => {
                return Promise.resolve(err);
            });
    }

    _generateDataForSlick() {
        const cache = this._backupsFeed;
        this._slickData = [];
        const canRestoreBackup = this.canRestoreBackup;

        cache.forEach((entity) => {
            const entry = {};
            entry.id = entity.getId();
            entry.createdOn = entity.getCapturedTime();
            entry.name = entity.getDescription();
            entry.createdBy = entity.getInitiatorUser();
            entry.size = _.get(entity, "catalog.size", 0);
            entry.os = _.get(entity, "_pristineProperties.detectedOs", "");
            entry.osVersion = _.get(entity, "_pristineProperties.detectedSoftwareVersion", "");
            entry.sku = _.get(entity, "_pristineProperties.detectedSku", "");
            entry.serial = _.get(entity, "_pristineProperties.detectedSerialNumber", "");
            entry.checksum =
                _.get(entity, "catalog.checksum.value") ||
                _.get(entity, "catalog.checksum.md5") ||
                _.get(entity, "catalog.checksum.sha1") ||
                _.get(entity, "catalog.checksum.sha256") ||
                _.get(entity, "catalog.checksum.sha512") ||
                "";
            entry.snapshotId = _.get(entity, "_pristineProperties.configurationId", "");
            entry.hasRestorePerm = canRestoreBackup;

            entry.deviceData = {
                os: this._device.getDetectedOs(),
                osVersion: this._device.detectedSoftwareVersion,
                sku: this._device.getDetectedSku(),
            };

            this._slickData.push(entry);
        });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DeviceRestoreViewComponent;

DeviceRestoreViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.io",
    "$teve.entities.DeviceBackupConfiguration",
    "gameEditor.viewState",
];

DeviceRestoreViewComponent.$displayDetails = {
    type: "View",
    name: "Backups",
    icon: "common.backup",
    shown: true,
    title: "Backups",
    order: 9,
};
